import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ListaComponent } from './lista/lista.component';
import { TramiteTituloComponent } from "./tramite-titulo/tramite-titulo.component";
//import { AuthGuard } from 'app/auth-guard.service';
import { AuthGuard } from '../../auth-guard.service';


const routes: Routes = [
  {
    path:'control-escolar/titulacion',  
    children:[
      {path:'lista', component:ListaComponent},
      {path:'tramite', component:TramiteTituloComponent},
    ],
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TitulacionRoutingModule { }
